import { render, staticRenderFns } from "./LongTable.vue?vue&type=template&id=40dffefa&scoped=true&"
import script from "./LongTable.vue?vue&type=script&lang=js&"
export * from "./LongTable.vue?vue&type=script&lang=js&"
import style0 from "./LongTable.vue?vue&type=style&index=0&id=40dffefa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dffefa",
  null
  
)

export default component.exports